import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import RangeCalendar from 'rc-calendar/lib/RangeCalendar';
import moment from 'moment';
import 'moment/locale/en-gb';

const getLocale = () => 'en-gb';
const getOffset = () => 0;

const getDefaultValue = (value, format) => {
    if (value && value !== '') {
        const val = value.split('-');
        return [moment(val[0], format), moment(val[1], format)];
    }
    const now = moment().locale(getLocale()).utcOffset(getOffset());
    return [now.clone().add(-1, 'months'), now];
};

function DateRangePicker({ onSelectionChange, format, value }) {
    const locale = useMemo(getLocale, []);
    const offset = useMemo(getOffset, []);

    useEffect(() => {
        moment.locale(locale);
    }, [locale]);

    const defaultValue = useMemo(
        () => getDefaultValue(value, format),
        [value, format, locale, offset]
    );

    const handleChange = (selected) => {
        if (selected[0] && selected[1] && onSelectionChange) {
            const dateRangeValue = `${selected[0].format(format)} - ${selected[1].format(format)}`;
            onSelectionChange(dateRangeValue);
        }
    };

    const disabledDate = (current) => {
        const today = moment();
        return (
            current.startOf('day').isAfter(today.endOf('day')) ||
            current.startOf('day').isBefore('1800-01-01', 'year')
        );
    };

    return (
        <RangeCalendar
            showToday={false}
            defaultValue={defaultValue}
            selectedValue={defaultValue}
            dateInputPlaceholder={['start', 'end']}
            showOk={false}
            showClear={false}
            format={format}
            onChange={handleChange}
            disabledDate={disabledDate}
        />
    );
}

DateRangePicker.propTypes = {
    onSelectionChange: PropTypes.func,
    format: PropTypes.string,
    value: PropTypes.string,
};

DateRangePicker.defaultProps = {
    format: 'YYYYMMDD',
    value: '',
};

export default DateRangePicker;